// ═══════════════════════════════════════════════════════════════════════════
// PAGE: MON COMPTE (août 2026)
// Consentement IA, crédits, notifications, relances de comité, mascotte, mot
// de passe, sondage. Était une modale ouverte depuis le menu du compte ;
// passée en page pour que le réglage des relances ait une URL — le pied des
// mails groupés y renvoie (cf. docs/MAILS.md § 1.4).
//
// Le rendu et le câblage restent dans `header.ts` (`renderMyAccountPage`),
// avec les helpers du sondage et la modale de changement de mot de passe.
// Ce module n'existe que pour enregistrer la page auprès du routeur.
// ═══════════════════════════════════════════════════════════════════════════

import { renderMyAccountPage } from './header.js';

pages.myAccount = async function () {
  await renderMyAccountPage();
};

export {};
